import {
  getLeoUuid,
  LeoUUID,
  getString,
  getLeoTimestamp,
  LeoTimestamp,
} from "@surya-digital/leo-ts-types";

export interface GetArchivedSpocProjectsPaginationResponseDTO {
  projectId: string;
  projectName: string;
  creator: string;
  surveys: string;
  createdOn: string;
  lastModified: string;
  spocId: string;
}

export class GetArchivedSpocProjectsPaginationResponse {
  readonly isGetArchivedSpocProjectsPaginationResponseGetArchivedSpocProjectsPaginationResponse: boolean = true;

  readonly projectId: LeoUUID;
  readonly projectName: string;
  readonly creator: string;
  readonly surveys: string;
  readonly createdOn: LeoTimestamp;
  readonly lastModified: LeoTimestamp;
  readonly spocId: LeoUUID;


  constructor(
  projectId: LeoUUID, 
  projectName: string, 
  creator: string, 
  surveys: string, 
  createdOn: LeoTimestamp, 
  lastModified: LeoTimestamp, 
  spocId: LeoUUID
  ) {
    this.projectId = projectId;
    GetArchivedSpocProjectsPaginationResponse.validateProjectName(projectName);
    this.projectName = projectName;
    GetArchivedSpocProjectsPaginationResponse.validateCreator(creator);
    this.creator = creator;
    GetArchivedSpocProjectsPaginationResponse.validateSurveys(surveys);
    this.surveys = surveys;
    this.createdOn = createdOn;
    this.lastModified = lastModified;
    this.spocId = spocId;
  }

  static fromDTO(dto: GetArchivedSpocProjectsPaginationResponseDTO): GetArchivedSpocProjectsPaginationResponse {
    const projectId = getLeoUuid(dto, "projectId", InvalidGetArchivedSpocProjectsPaginationResponseProjectIdError);
    const projectName = getString(dto, "projectName", InvalidGetArchivedSpocProjectsPaginationResponseProjectNameError);
    const creator = getString(dto, "creator", InvalidGetArchivedSpocProjectsPaginationResponseCreatorError);
    const surveys = getString(dto, "surveys", InvalidGetArchivedSpocProjectsPaginationResponseSurveysError);
    const createdOn = getLeoTimestamp(dto, "createdOn", InvalidGetArchivedSpocProjectsPaginationResponseCreatedOnError);
    const lastModified = getLeoTimestamp(dto, "lastModified", InvalidGetArchivedSpocProjectsPaginationResponseLastModifiedError);
    const spocId = getLeoUuid(dto, "spocId", InvalidGetArchivedSpocProjectsPaginationResponseSpocIdError);
    return new GetArchivedSpocProjectsPaginationResponse(
      projectId,
      projectName,
      creator,
      surveys,
      createdOn,
      lastModified,
      spocId
    );
  }

  toDTO(): GetArchivedSpocProjectsPaginationResponseDTO {
    const dto: GetArchivedSpocProjectsPaginationResponseDTO = {
        projectId: this.projectId.toDTO(),
        projectName: this.projectName,
        creator: this.creator,
        surveys: this.surveys,
        createdOn: this.createdOn.toDTO(),
        lastModified: this.lastModified.toDTO(),
        spocId: this.spocId.toDTO()
    };
    return dto;
  }
  private static validateProjectName = (projectName: string): void => {
    if(projectName.trim().length === 0) {
      throw new InvalidGetArchivedSpocProjectsPaginationResponseProjectNameNonEmptyError(
        `Attribute projectName cannot be an empty string.`
      );
    }
  }
  private static validateCreator = (creator: string): void => {
    if(creator.trim().length === 0) {
      throw new InvalidGetArchivedSpocProjectsPaginationResponseCreatorNonEmptyError(
        `Attribute creator cannot be an empty string.`
      );
    }
  }
  private static validateSurveys = (surveys: string): void => {
    if(surveys.trim().length === 0) {
      throw new InvalidGetArchivedSpocProjectsPaginationResponseSurveysNonEmptyError(
        `Attribute surveys cannot be an empty string.`
      );
    }
  }
  
}

GetArchivedSpocProjectsPaginationResponse.prototype.toString = function toString(): string {
  return `GetArchivedSpocProjectsPaginationResponse(projectId='${this.projectId}',projectName='${this.projectName}',creator='${this.creator}',surveys='${this.surveys}',createdOn='${this.createdOn}',lastModified='${this.lastModified}',spocId='${this.spocId}')`;
};

export class InvalidGetArchivedSpocProjectsPaginationResponseError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsPaginationResponseError";
  }
}
export class InvalidGetArchivedSpocProjectsPaginationResponseProjectIdError extends InvalidGetArchivedSpocProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsPaginationResponseProjectIdError";
  }
}

export class InvalidGetArchivedSpocProjectsPaginationResponseProjectNameError extends InvalidGetArchivedSpocProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsPaginationResponseProjectNameError";
  }
}

export class InvalidGetArchivedSpocProjectsPaginationResponseProjectNameNonEmptyError extends InvalidGetArchivedSpocProjectsPaginationResponseProjectNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsPaginationResponseProjectNameNonEmptyError";
  }
}

export class InvalidGetArchivedSpocProjectsPaginationResponseCreatorError extends InvalidGetArchivedSpocProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsPaginationResponseCreatorError";
  }
}

export class InvalidGetArchivedSpocProjectsPaginationResponseCreatorNonEmptyError extends InvalidGetArchivedSpocProjectsPaginationResponseCreatorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsPaginationResponseCreatorNonEmptyError";
  }
}

export class InvalidGetArchivedSpocProjectsPaginationResponseSurveysError extends InvalidGetArchivedSpocProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsPaginationResponseSurveysError";
  }
}

export class InvalidGetArchivedSpocProjectsPaginationResponseSurveysNonEmptyError extends InvalidGetArchivedSpocProjectsPaginationResponseSurveysError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsPaginationResponseSurveysNonEmptyError";
  }
}

export class InvalidGetArchivedSpocProjectsPaginationResponseCreatedOnError extends InvalidGetArchivedSpocProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsPaginationResponseCreatedOnError";
  }
}

export class InvalidGetArchivedSpocProjectsPaginationResponseLastModifiedError extends InvalidGetArchivedSpocProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsPaginationResponseLastModifiedError";
  }
}

export class InvalidGetArchivedSpocProjectsPaginationResponseSpocIdError extends InvalidGetArchivedSpocProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsPaginationResponseSpocIdError";
  }
}
